<div class="requests-container">
    <div class="header">
        <h1 class="header-text">Requests</h1>
    </div>
    <app-tabs #tabsComponent [style]="'menu-bar'"></app-tabs>
    <div class="data-container">
        <router-outlet></router-outlet>
    </div>
</div>
